<template>
  <div style="width:100%">
    <slot
      name="menu"
      :handleClick="handleClick"
      :handleBlur="handleBlur"
      :activeNav="activeNav"
      :navReady="navReady"
      :slideNav="slideNav"
      :resetSecondary="resetSecondary"
    ></slot>
  </div>
</template>

<script lang="js">
  import { mapState } from "vuex";

  export default {
    name: "lms-navigation",
    data() {
      return {
        activeNav: null,
        searchActive: false,
        navReady: false,
      };
    },
    computed: mapState(["searchOpen", "navOpen", "drawerOpen"]),
    watch: {
      searchOpen(newValue) {
        if (newValue) {
          this.resetNav();
        }
      },
      navOpen(newValue) {
        if (newValue) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "auto";
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.navReady = true;
      }, 200);
    },
    methods: {
      handleBlur() {
        this.$store.state.drawerOpen = false;
        this.$store.state.navOpen = false;
        
        // Re-focus on top-level nav
        this.$el
          .querySelectorAll(".nav__primary > li > a")
          [this.activeNav - 1].focus();
        this.activeNav = null;
      },
      handleClick(event, idx) {
        // if this link has no drawer items, pass through to its href
        if (!event.target.nextElementSibling) {
          window.location.href = event.target.href;
          // if an item is clicked that's
          // already active, close its drawer
        } else if (this.$breakpoint.lgAndUp && idx === this.activeNav) {
          this.$store.state.drawerOpen = false;
          this.activeNav = null;
        } else {
          // if another drawer is already open, delay a tick to let that drawer close
          if (this.$store.state.drawerOpen) {
            this.activeNav = idx;
          } else {
            if (this.$breakpoint.lgAndDown) {
              const leftColumnLinks = event.target.nextElementSibling.querySelector(
                ".nav__columns--left"
              );
              const rightColumnLinks = event.target.nextElementSibling.querySelector(
                ".nav__columns--right"
              );

              if (leftColumnLinks === null && rightColumnLinks === null) {
                // If the user is on mobile, and clicks a primary menu item that has no left or right column
                // links, then follow the primary link.
                window.location.href = event.target.href;
                return;
              }
            }

            this.$store.state.drawerOpen = true;
            this.activeNav = idx;
          }
        }
        this.$store.state.navOpen = this.$store.state.drawerOpen;
      },
      resetNav() {
        this.$store.state.navOpen = false;
        this.$store.state.drawerOpen = false;
        this.activeNav = null;
      },
      resetSecondary() {
        this.$store.state.drawerOpen = false;
        // if mobile, slide the primary nav to the left
        if (this.$breakpoint.mdAndDown) {
          document.querySelector(".nav__group").classList.remove("active");
        }
      },
      slideNav() {
        if (this.$breakpoint.mdAndDown) {
          document.querySelector(".nav__group").classList.toggle("active");
        }
      },
    },
  };
</script>
